import FolderOffIcon from '@mui/icons-material/FolderOff';
import { Stack, Typography } from '@mui/material';
import PaiLink from 'features/ui/base-components/pai-link';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  handleOpenAddLocalBlacklistDialog(): void;
}

const NoLocalBlacklistsFound: React.FC<Props> = ({ handleOpenAddLocalBlacklistDialog }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <div className={classes.noLocalBlacklistsFound}>
      <FolderOffIcon className={classes.icon} />
      <Stack gap={1} alignItems={'center'}>
        <Typography className={classes.greyText}>{t('noCampaignSpecificBlacklist')}</Typography>
        <PaiLink
          text={t('addNewCampaignSpecificBlacklist')}
          size={'lg'}
          variant={'primary'}
          underline={'always'}
          action={handleOpenAddLocalBlacklistDialog}
        />
      </Stack>
    </div>
  );
};

const useStyles = makeStyles()((theme) => ({
  noLocalBlacklistsFound: {
    height: '100%',
    overflow: 'auto',
    border: `1px solid ${theme.palette.greys.light}`,
    borderRadius: '12px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon: {
    fontSize: theme.typography.pxToRem(80),
    marginBottom: '32px',
    color: theme.palette.greys.medium,
  },
  greyText: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.greys.medium,
  },
}));

export default NoLocalBlacklistsFound;
